import React from 'react';
import Modal from 'PageTemplates/ModalTemplate';
import FlexRow from 'PageTemplates/FlexRowTemplate';
import { Card } from 'react-bootstrap';
import styled from 'styled-components';
import { colorSamplesTypes } from 'services/utils/const';
import { useDispatch } from 'react-redux';
import {
  addSampleType,
  removeSampleType,
} from 'services/store/actions/newOrder';

const StyledCard = styled(Card)`
  width: 220px;
  margin: 10;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  background-color: ${(props) =>
    props.selected ? '#d0ffd2ff' : props.disabled ? '#f0f0f0' : 'white'};
`;

const ColorSamplesModal = ({ closeModal, order }) => {
  const dispatch = useDispatch();

  const handleSampleTypeChange = (sampleType) => {
    if (isDisabled(sampleType)) return;
    if (order.samplesTypes.includes(sampleType)) {
      dispatch(removeSampleType(sampleType));
    } else {
      dispatch(addSampleType(sampleType));
    }
  };

  const isDisabled = (sampleType) => {
    if (sampleType === 'mdf frezowany') {
      return order.millings.length === 0;
    }
    return false;
  };

  const getTitle = (sampleType) => {
    if (isDisabled(sampleType)) {
      return 'Wybierz rodzaj frezowania, aby dodać ten typ próbki';
    }
    return '';
  };

  return (
    <Modal
      title="Typy próbek"
      closeModal={closeModal}
      size="lg"
      footer={<div />}
    >
      <FlexRow justify="space-between">
        {Object.values(colorSamplesTypes).map((sample) => (
          <StyledCard
            key={sample.type}
            selected={order.samplesTypes.includes(sample.type)}
            disabled={isDisabled(sample.type)}
            onClick={() => handleSampleTypeChange(sample.type)}
            title={getTitle(sample.type)}
          >
            <Card.Body style={{ padding: 5 }}>
              <Card.Title
                style={{ fontSize: 16, margin: 0, textAlign: 'center' }}
              >
                {sample.title}
              </Card.Title>
              <Card.Text style={{ fontSize: 12, textAlign: 'center' }}>
                Wymiary {sample.dimensions} <br />
                {getTitle(sample.type)}
              </Card.Text>
            </Card.Body>
          </StyledCard>
        ))}
      </FlexRow>
    </Modal>
  );
};

export default ColorSamplesModal;
